<template>
  <div class="w-screen max-w-full min-h-screen">
    <main>
      <div class="bg_row" />
      <header class="p-9 relative z-10">
        <div class="flex items-center justify-between gap-5 flex-wrap">
          <div class="h-16 max-w-xs">
            <img :src="'/logo-slim.png'" alt="Logo" class="w-full h-full" />
          </div>
          <div class="flex justify-between items-center gap-3">
            <p class="text-xl">
              <strong>{{ $page.props.auth.user.first_name }}</strong
              ><strong>{{ $page.props.auth.user.last_name }}</strong>
            </p>
            <icon class="w-7 h-7 ml-3 fill-black" name="gear" />
            <inertia-link :href="route('logout')" method="delete">
              <icon class="w-7 h-7 ml-3 fill-black" name="exit" />
            </inertia-link>
          </div>
        </div>
        <h2>
          Olá, <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong
          ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong>
        </h2>
      </header>
      <section
        class="p-9 relative z-10 mt-5"
        v-if="
          $page.props.auth.user.email !== 'subir_imagens@gmail.com' &&
          $page.props.auth.user.email !== 'sistema_de_monitoramento@gmail.com'
        "
      >
        <div class="mb-12">
          <p class="mb-5 font-medium text-2xl text-gray-700">Explore por categoria</p>

          <div class="flex justify-start gap-12 flex-wrap items-center">
            <inertia-link
              v-for="(shortut, index) in indicators_shortcuts"
              :key="index"
              :href="route(shortut.url, { menu: shortut.icon })"
            >
              <div class="card">
                <div class="mb-6">
                  <div
                    class="h-20 w-20 rounded-xl flex items-center justify-center icon_green_container"
                  >
                    <img :src="`/i-green-${shortut.icon}.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">{{ shortut.label }}</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_green_container">
                    <icon class="w-14 h-14 icon_green" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>

            <inertia-link :href="route('dashboard')">
              <div class="card">
                <div class="mb-6">
                  <div
                    class="h-20 w-20 rounded-xl flex items-center justify-center icon_green_container"
                  >
                    <icon class="w-11 h-11 icon_green" name="dashboard" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Fluxo Turistico</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_green_container">
                    <icon class="w-14 h-14 icon_green" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>

            <a v-if="$page.props.auth.user.url" :href="$page.props.auth.user.url">
              <div class="card">
                <div class="mb-6">
                  <div
                    class="h-20 w-20 rounded-xl flex items-center justify-center icon_green_container"
                  >
                    <img :src="`/i-green-chart.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Pesquisa de demanda - smartsurvey</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_green_container">
                    <icon class="w-14 h-14 icon_green" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </a>

            <inertia-link :href="route('welcome')">
              <div class="card">
                <div class="mb-6">
                  <div
                    class="h-20 w-20 rounded-xl flex items-center justify-center icon_green_container"
                  >
                    <icon class="w-11 h-11 icon_green" name="gear" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Menu inicial</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_green_container">
                    <icon class="w-14 h-14 icon_green" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>
          </div>
        </div>
        <div>
          <p class="mb-5 font-medium text-2xl text-gray-700">Sistema Especialista</p>
          <div class="flex justify-start gap-12 flex-wrap items-center">
            <inertia-link :href="route('indicators', { menu: 'SET-mini' })">
              <div class="card">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`set-purple-graph.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Radar SET - DTI</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>
            <inertia-link :href="route('indicators', { menu: 'chart' })">
              <div class="card">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`set-purple-graph.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Inteligência de Mercado</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>
            <div
              v-for="(shortcut, index) in set_shortcuts"
              :key="index"
              class="card"
              @click="showAlert"
            >
              <div class="mb-6">
                <div class="h-20 w-20 rounded-xl purple_dark flex items-center justify-center">
                  <img :src="`/set-purple-${shortcut.icon}.png`" alt="card-icon" class="w-14" />
                </div>
              </div>
              <div>
                <p class="text-xl">{{ shortcut.label }}</p>
              </div>
              <div class="flex justify-end">
                <div class="w-14 h-14 rounded-xl icon_purple_container">
                  <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                </div>
              </div>
            </div>

            <inertia-link :href="route('social')" v-if="hasPerm('social-media')">
              <div class="card">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`redessocoais_360.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Redes Sociais</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>
            <inertia-link :href="route('reviews')" v-if="hasPerm('reviews')">
              <div class="card">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`reviews.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Reviews</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </inertia-link>

            <div
              v-if="
                $page.props.auth.user.email === 'super@smart-destination.com' ||
                $page.props.auth.user.email === 'turismosustentavel@pti.org.br'
              "
            >
              <inertia-link :href="route('transport-modes')">
                <div class="card">
                  <div class="mb-6">
                    <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                      <img :src="`modall.png`" class="w-14" />
                    </div>
                  </div>
                  <div>
                    <p class="text-xl">Sistema Preditivo de Modais</p>
                  </div>
                  <div class="flex justify-end">
                    <div class="w-14 h-14 rounded-xl icon_purple_container">
                      <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                    </div>
                  </div>
                </div>
              </inertia-link>
            </div>

            <div
              v-if="
                $page.props.auth.user.email === 'super@smart-destination.com' ||
                $page.props.auth.user.email === 'bruno.cardosof@gmail.com'
              "
            >
              <div class="card" style="cursor: pointer" @click="handleRedirectMonitoringSystem">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`segg.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Sistema de Monitoramento</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
              @click="isAllowedUserForSecurityPage"
            >
              <!-- Lógica para mostrar o card de segurança apenas para o usuário 'testes@gmail.com' -->
              <div class="card">
                <div class="mb-6">
                  <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                    <img :src="`segg.png`" class="w-14" />
                  </div>
                </div>
                <div>
                  <p class="text-xl">Sistema Preditivo de Segurança Pública</p>
                </div>
                <div class="flex justify-end">
                  <div class="w-14 h-14 rounded-xl icon_purple_container">
                    <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                  </div>
                </div>
              </div>

              <!-- dispara o alert se o usuário não for 'testes@gmail.com' -->
              <!-- <div v-else @click="showAlert" style="cursor: pointer">
                <div class="card">
                  <div class="mb-6">
                    <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                      <img :src="`segg.png`" class="w-14" />
                    </div>
                  </div>
                  <div>
                    <p class="text-xl">Sistema Preditivo de Segurança Pública</p>
                  </div>
                  <div class="flex justify-end">
                    <div class="w-14 h-14 rounded-xl icon_purple_container">
                      <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section
        class="p-9 relative z-10 mt-5"
        v-if="$page.props.auth.user.email === 'subir_imagens@gmail.com'"
      >
        <div class="mb-12">
          <p class="mb-5 font-medium text-2xl text-gray-700">
            Imagens para o sistema de monitoramento
          </p>

          <div
            class="flex justify-start gap-12 flex-wrap items-center"
            @click="handleRedirectUploadImages"
          >
            <div class="card">
              <div class="mb-6">
                <div
                  class="h-20 w-20 rounded-xl flex items-center justify-center icon_green_container"
                >
                  <icon class="w-11 h-11 icon_green" name="image" />
                </div>
              </div>
              <div>
                <p class="text-xl">Upload das imagens</p>
              </div>
              <div class="flex justify-end">
                <div class="w-14 h-14 rounded-xl icon_green_container">
                  <icon class="w-14 h-14 icon_green" name="cheveron-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="p-9 relative z-10 mt-5"
        v-if="$page.props.auth.user.email === 'sistema_de_monitoramento@gmail.com'"
      >
        <div class="mb-12">
          <p class="mb-5 font-medium text-2xl text-gray-700">
            Imagens para o sistema de monitoramento
          </p>

          <div class="card" style="cursor: pointer" @click="handleRedirectMonitoringSystem">
            <div class="mb-6">
              <div class="h-20 w-20 rounded-xl flex items-center justify-center purple_dark">
                <img :src="`segg.png`" class="w-14" />
              </div>
            </div>
            <div>
              <p class="text-xl">Sistema de Monitoramento</p>
            </div>
            <div class="flex justify-end">
              <div class="w-14 h-14 rounded-xl icon_purple_container">
                <icon class="w-14 h-14 icon_purple" name="cheveron-right" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModalError :errorMessage="errorMessage" :show="showErrorModal" @close="closeModal" />
    </main>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import ModalError from './ModalError.vue'
import {
  defaultComponents,
  defaultEconomicPerformanceComponents,
} from '../../Helpers/transportModes'

export default {
  metaInfo: { title: 'Home' },
  components: {
    Icon,
    ModalError,
  },
  props: {
    error: {
      type: String,
      default: null,
    },
    shortcuts: Array,
  },
  data() {
    return {
      indicators_shortcuts: [],
      set_shortcuts: [],
      showErrorModal: false,
      errorMessage: null,
    }
  },
  mounted() {
    //Configs padrões do dash transportes de modais -> temporariamente aqui
    !!!localStorage.getItem('customHeaderComponents') &&
      localStorage.setItem('customHeaderComponents', JSON.stringify(defaultComponents))
    !!!localStorage.getItem('customHeaderEconomicPerformanceComponents') &&
      localStorage.setItem(
        'customHeaderEconomicPerformanceComponents',
        JSON.stringify(defaultEconomicPerformanceComponents),
      )
    if (this.$page.props.error) {
      this.showErrorModal = true
      this.errorMessage = this.$page.props.error
    }
    this.indicators_shortcuts = this.shortcuts.filter((shortcut) =>
      shortcut.url.includes('indicators'),
    )

    this.set_shortcuts = this.shortcuts.filter((shortcut) => shortcut.url.includes('set'))
  },
  methods: {
    hasPerm(perm) {
      return this.$page.props.auth.user.roles.includes(perm)
    },
    showAlert() {
      this.showErrorModal = true
      this.errorMessage = 'Funcionalidade em Desenvolvimento.'
    },
    closeModal() {
      this.showErrorModal = false
    },

    isAllowedUserForSecurityPage() {
      const allowedEmails = [
        'super@smart-destination.com',
        'clara.cavalcanti@recife.pe.gov.br',
        'observatoriodeturismo@recife.pe.gov.br',
        'teste@gmail.com',
      ]
      const currentUserEmail = this.$page.props.auth.user.email
      if (!allowedEmails.includes(currentUserEmail)) {
        this.showErrorModal = true
        this.errorMessage = 'Você não tem acesso a este módulo.'
      } else {
        this.$inertia.visit(route('security'))
      }
    },
    handleRedirectMonitoringSystem() {
      window.open('http://smartdestination-admin.com.br/density-vision')
    },
    handleRedirectUploadImages() {
      window.open('http://smartdestination-admin.com.br/density-vision/upload')
    },
  },
}
</script>

<style scoped>
main {
  position: relative;
  background-color: #f2f4f5;
}

.bg_row {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 360px;
  background: linear-gradient(
    271deg,
    #00a39a 17.66%,
    rgba(0, 163, 154, 0.5) 41.01%,
    rgba(0, 163, 154, 0.1) 75.76%
  );
  z-index: 1;
}

header h2 {
  margin: 40px 0 10px 0;
  font-size: 32px;
  font-weight: 500;
}

header p {
  font-size: 16px;
  font-weight: 400;
}

section .card {
  height: 250px;
  width: 380px;
  background-color: #fff;
  border-radius: 12px;
  margin: 10px 0;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  padding: 25px;
  transition: all 0.7s ease;
}

section .card:hover {
  transform: scale(1.1);
}

.icon_green_container {
  background: rgba(100, 180, 200, 0.2);
}

.icon_green {
  fill: #00a39a;
}

.icon_purple_container {
  background-color: #fbecfd;
}

.icon_purple {
  fill: #d538e3;
}

.purple_dark {
  border-radius: 16px;
  background: #001a28;
}
</style>
